import React from 'react';
import I18n from 'i18n-js';
import bind from '@reverbdotcom/commons/src/bind';
import gql from 'graphql-tag';

import Jumplinks, { IJumplink } from '@reverbdotcom/commons/src/components/jumplinks';
import { RCStarRating } from '@reverbdotcom/cadence/components';
import RouterHistory from '@reverbdotcom/commons/src/cms/lib/router_history';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import experiments from '@reverbdotcom/commons/src/experiments';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import { IUserContext } from '@reverbdotcom/commons';

import {
  CSP,
} from '../schemas/rql';

export const JUMPLINK_LISTINGS = 'listings';
export const JUMPLINK_PRICEGUIDE = 'price-guide';
export const JUMPLINK_SIMILAR = 'similar-products';
export const JUMPLINK_REVIEWS = 'reviews-section';
export const JUMPLINK_BLURB = 'blurb';
export const JUMPLINK_GALLERY = 'gallery';
export const JUMPLINK_VIDEO = 'video';
export const JUMPLINK_SPECS = 'specs';
export const JUMPLINK_OVERVIEW = 'overview';

export const JUMPLINK_ORDER = [
  JUMPLINK_LISTINGS,
  JUMPLINK_OVERVIEW,
  JUMPLINK_VIDEO,
  JUMPLINK_GALLERY,
  JUMPLINK_SPECS,
  JUMPLINK_SIMILAR,
  JUMPLINK_PRICEGUIDE,
  JUMPLINK_REVIEWS,
  JUMPLINK_BLURB,
];

export interface IJumplinkProps extends IUserContext {
  [JUMPLINK_LISTINGS]?: boolean;
  [JUMPLINK_OVERVIEW]?: boolean;
  [JUMPLINK_SPECS]?: boolean;
  [JUMPLINK_VIDEO]?: boolean;
  [JUMPLINK_GALLERY]?: boolean;
  [JUMPLINK_SIMILAR]?: boolean;
  [JUMPLINK_PRICEGUIDE]?: boolean;
  [JUMPLINK_REVIEWS]?: boolean;
  [JUMPLINK_BLURB]?: boolean;
  csp?: CSP;
}

const SIDEBAR_JUMPLINKS = [
  JUMPLINK_OVERVIEW,
  JUMPLINK_VIDEO,
  JUMPLINK_GALLERY,
  JUMPLINK_SPECS,
];

export class CSP2Jumplinks extends React.Component<IJumplinkProps, null> {
  @bind
  buildJumplink(id): IJumplink {
    if (!this.props[id]) return null;
    const text = I18n.t(
      `discovery.comparisonShoppingPages.jumpLinks.${id}`,
    );

    let content;
    if (id === JUMPLINK_REVIEWS) {
      content = (
        <div className="d-flex">
          {text}
          {!!this.props.csp?.reviews?.total &&
            <div className="ml-1">
              <RCStarRating
                rating={this.props.csp.reviews?.avgRating / 5.0}
                count={this.props.csp.reviews?.total}
              />
            </div>
          }
        </div>
      );
    } else {
      content = text;
    }

    const baseJumplink = {
      id,
      text: content,
      inSidebar: SIDEBAR_JUMPLINKS.indexOf(id) > -1,
    };

    const clickEvent = {
      componentName: 'CSP2Jumplinks',
      eventName: MParticleEventName.ClickedJumplinkToCSPPriceGuideModule,
      cspId: this.props.csp?.id,
      cspSlug: this.props.csp?.slug,
      experiments: formatExperimentsForEventAttributes(this.props.user, [
        experiments.PRICE_GUIDE_TOOL_CSP_MODULE_V2,
      ]),
    };

    switch (id) {
      case JUMPLINK_PRICEGUIDE:
        return {
          ...baseJumplink,
          clickEvent,
        };
      default:
        return baseJumplink;
    }
  }

  dropdownJumplinks() {
    return (
      JUMPLINK_ORDER.map((name) => {
        if (!this.props[name]) { return null; }

        const text = I18n.t(`discovery.comparisonShoppingPages.jumpLinks.${name}`);

        return <option key={name} value={`#${name}`}>{text}</option>;
      })
    );
  }

  render() {

    return (
      <>
        <div className="csp2-jumplinks__dropdown">
          <div className="csp2-jumplinks__dropdown__inner">
            <div className="csp2-jumplinks__dropdown__title">
              {I18n.t('discovery.comparisonShoppingPages.jumpTo')}
            </div>
            <div className="styled-dropdown">
              <select
                onChange={(e) => {
                  const location = {
                    hash: e.target.value,
                    pathname: window.location.pathname,
                  };

                  if (e.target.value.includes(JUMPLINK_PRICEGUIDE)) {
                    trackEvent({
                      componentName: 'CSP2Jumplinks',
                      eventName: MParticleEventName.ClickedJumplinkToCSPPriceGuideModule,
                      cspId: this.props.csp?.id,
                      cspSlug: this.props.csp?.slug,
                      experiments: formatExperimentsForEventAttributes(this.props.user, [
                        experiments.PRICE_GUIDE_TOOL_CSP_MODULE_V2,
                      ]),
                    });
                  }

                  RouterHistory.push(location);
                }}>
                <option disabled selected>{I18n.t('discovery.comparisonShoppingPages.jumpLinks.placeholder')}</option>
                {this.dropdownJumplinks()}
              </select>
            </div>
          </div>
        </div>
        <div className="csp2-jumplinks--hide-mobile">
          <Jumplinks
            jumplinks={JUMPLINK_ORDER.map(this.buildJumplink).filter(Boolean)}
          />
        </div>
      </>
    );
  }
}

export const CSPJumplinksFragment = gql`
  fragment CSPReviewJumplinksData on CSP {
    _id
    reviews {
      total
      avgRating
    }
  }
`;

export default CSP2Jumplinks;
